<div class="mainbox">
    <div class="leftsidebar">
        &nbsp;
    </div>
    <div class="submainbox">
        <div>
            <h2>Portal Maintenance</h2>
            <p *ngIf="loaded && !isFullAdmin()">
                These settings are read-only for your role. Only full administrators may save changes.
            </p>
            <form [formGroup]="portalMaintenanceForm">
                <div>
                    <mat-checkbox formControlName="available">
                        Portal available (uncheck to put the portal into maintenance mode)
                    </mat-checkbox>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Timezone (for entering the time below)</mat-label>
                        <mat-select [(ngModel)]="selectedTimeZone" [ngModelOptions]="{standalone: true}"
                            (selectionChange)="onTimeZoneChange()">
                            <mat-option *ngFor="let tz of timezones" [value]="tz.id">{{tz.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Next maintenance</mat-label>
                        <input matInput type="datetime-local" formControlName="next_maintenance" />
                    </mat-form-field>
                    <p class="hint">Entered in the selected timezone; stored as UTC and shown to each user in their own local time.</p>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="fullwidth">
                        <mat-label>Maintenance message</mat-label>
                        <textarea matInput rows="4" formControlName="next_maintenance_message"></textarea>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Expected downtime (hours)</mat-label>
                        <input matInput type="number" min="0" formControlName="next_maintenance_downtime_hours" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Show maintenance message (days before)</mat-label>
                        <input matInput type="number" min="0" formControlName="show_maintenance_lead_days" />
                    </mat-form-field>
                </div>
                <div class="vcenter buttonrow">
                    <button mat-raised-button color="primary" (click)="save()"
                        [disabled]="!isFullAdmin() || !portalMaintenanceForm.valid">Save</button>
                    <button mat-stroked-button color="accent" (click)="deploymentComplete()"
                        matTooltip="Bring the portal back up and clear the maintenance message."
                        [disabled]="!isFullAdmin()">Deployment complete</button>
                </div>
            </form>
        </div>
    </div>
    <div class="rightsidebar">
        &nbsp;
    </div>
</div>
